export default "__VITE_ASSET__CAi3jjyB__"